module.exports = __webpack_public_path__ + "img/undertakingCases3.65bea7cb.jpg";